import { faGripVertical } from '@fortawesome/pro-regular-svg-icons';
import { FC } from 'react';
import { Icon } from 'src/components/Icon';
import { IconButton } from 'src/components/IconButton';

import { automationDragHighlightBg } from './automationDragStyles';

interface AutomationDragHandleProps {
  active?: boolean;
  disabled?: boolean;
  label: string;
  /** Muted handle for the stationary drop placeholder (not the drag overlay). */
  placeholder?: boolean;
}

export const AutomationDragHandle: FC<AutomationDragHandleProps> = ({
  active = false,
  disabled = false,
  label,
  placeholder = false,
}) => {
  const borderColor = active ? 'primary.main' : 'neutral.6';

  return (
    <IconButton
      aria-label={label}
      disabled={disabled}
      size="small"
      sx={[
        {
          borderColor,
          color: active ? 'primary.dark' : 'text.secondary',
          cursor: disabled ? 'not-allowed' : 'grab',
          flexShrink: 0,
          '&:hover': {
            borderColor,
          },
        },
        placeholder
          ? (theme) => ({
              bgcolor: 'transparent',
              ...theme.applyStyles('dark', {
                borderColor: 'neutral.7',
                color: 'text.disabled',
              }),
            })
          : active
            ? (theme) => ({
                ...automationDragHighlightBg(theme),
                ...theme.applyStyles('dark', {
                  color: 'primary.11',
                }),
              })
            : { bgcolor: 'background.paper' },
      ]}
      variant="tertiary"
    >
      <Icon icon={faGripVertical} size="xsmall" />
    </IconButton>
  );
};
